import React, { useEffect, useRef } from "react";

import { Link } from "react-router-dom";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Typography, Stack } from "@mui/material";

import styles from "./Header.module.scss";

function HeaderMenu({ item }) {
  const [showDropdown, setShowDropdown] = React.useState(false);
  const ref = useRef();

  useEffect(() => {
    const handler = (event) => {
      if (showDropdown && ref.current && !ref.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [showDropdown]);

  return (
    <li className={styles.menuItems} ref={ref}>
      <Stack direction="row" alignItems="center">
        <Button
          type="button"
          aria-haspopup="menu"
          aria-expanded={showDropdown ? "true" : "false"}
          onClick={() => setShowDropdown((prev) => !prev)}
          sx={{
            bgcolor: "transparent",
            minWidth: "auto",
            color: "#002238",
            padding: "6px 0",
            "&.MuiButton-root": {
              fontSize: "1.6rem",
              borderRadius: "0",
              fontWeight: "600"
            },
            "&:hover": {
              bgcolor: "transparent"
            }
          }}
        >
          <Typography fontWeight="600" mr="5px" p="6px 0 2px 0" sx={{ borderBottom: "1px solid rgb(0, 34, 56, .5)" }}>
            {item.title}
          </Typography>
          {showDropdown ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Button>
      </Stack>
      <ul className={`${styles.dropdown} ${styles.subMenu} ${showDropdown ? styles.show : ""}`}>
        {item.children.map((submenu) => (
          <Link to={submenu.route} key={submenu.title}>
            <Button component="li" className={styles.menuItems} onClick={() => setShowDropdown(false)}>
              <Typography fontWeight="500">{submenu.title}</Typography>
            </Button>
          </Link>
        ))}
      </ul>
    </li>
  );
}

export default HeaderMenu;
